module.exports.getHost = () => {
  if (process.env.NODE_ENV === "development") {
    return "https://app.grabbngo.com";
  } else if (process.env.NODE_ENV === "production") {
    //console.log = () => {};
    return "https://app.grabbngo.com";
  }
};

module.exports.getPrinter = () =>{return "http://localhost:53921/print/"};
module.exports.getPrinterinfo = () =>{return "http://localhost:53921/printer-info/"};


// WEBPACK FOOTER //
// ./src/config/index.js